import React from 'react';
import { getGridCoords, resourceConsolidation } from '../utils/resourceUtils';
import styled from 'styled-components';
import ResourceBlock from './ResourceBlock';

const ResourceTracker = (props) => {
  const {
    resourceData,
    selectResource,
    selectedResource,
    type,
    idBase,
    ...rest
  } = props;
  const amount = resourceData?.amount || 0;
  const production = resourceData?.production || 0;
  const minMod = props.minMod;

  const flip = ['plants', 'energy', 'heat'].includes(type);

  const { gold, silver, copper } = resourceConsolidation(amount);

  const resourceSelected = selectedResource === type;
  const productionSelected = selectedResource === `${type}Production`;

  const goldBlocks = Array(gold)
    .fill(null)
    .map((_, i) => (
      <ResourceBlock key={i} type="gold" blockSize={props.blockSize} />
    ));
  const silverBlocks =
    silver > 0
      ? Array(silver)
          .fill(null)
          .map((_, i) => (
            <ResourceBlock key={i} type="silver" blockSize={props.blockSize} />
          ))
      : null;
  const copperBlocks = Array(copper)
    .fill(null)
    .map((_, i) => (
      <ResourceBlock key={i} type="copper" blockSize={props.blockSize} />
    ));

  const { col, row } = getGridCoords(production, minMod);

  return (
    <Container id={idBase + 'Container'} className={type} flip={flip} {...rest}>
      <VisualArea
        id={idBase + 'Total'}
        className={flip ? `${type} amount flipped` : `${type} amount`}
        onClick={() => selectResource(type)}
        highlighted={resourceSelected}
      >
        <Resource blockSize={props.blockSize}>
          {goldBlocks}
          {silverBlocks}
          {copperBlocks}
        </Resource>
        <ButtonArea>
          <Total>{amount}</Total>
        </ButtonArea>
      </VisualArea>
      <ProductionArea
        id={idBase + 'Production'}
        className={flip ? `${type} production flipped` : `${type} production`}
        onClick={() => selectResource(type + 'Production')}
        highlighted={productionSelected}
      >
        <Marker className="marker" col={col} row={row}>
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g>
              <text
                className="sum"
                x="50%"
                y="50%"
                textAnchor="middle"
                dy=".3em"
              >
                {production}
              </text>
            </g>
          </svg>
        </Marker>
      </ProductionArea>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.flip ? 'column-reverse' : 'column')};
  font-size: 24px;

  &.steel,
  &.titanium {
    height: 90%;

    .amount {
      height: 80%;
    }
  }
`;

const VisualArea = styled.div`
  display: flex;
  justify-content: space-between;
  height: 59%;
  position: relative;
  border-radius: 5px;
  border: ${(props) => props.highlighted && '5px solid lime'};
`;

const ButtonArea = styled.div`
  height: 100%;
  width: 15%;
`;

const Total = styled.div`
  color: black;
  font-weight: bold;
  background-color: gold;
  padding: 0.7%;
  text-align: center;
  border-radius: 5px;
  box-shadow: -2px 2px 7px 2px rgba(0, 0, 0, 1);
`;

const Resource = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(${({ rows }) => rows || 3}, 1fr);
  column-gap: ${({ blockSize }) => blockSize * 0.7}px;
  padding: 1%;
`;

const ProductionArea = styled.div`
  color: white;
  text-align: center;
  height: 40%;
  padding: 6% 8.5% 4% 3%;

  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  place-items: center;
  row-gap: 4%;

  border: ${(props) => props.highlighted && '5px solid lime'};

  &.flipped {
    height: 35%;
    margin-bottom: 5%;
  }

  &.money {
    padding: 4.5% 6.5% 2% 32%;
    grid-template-rows: repeat(3, 1fr);
  }
  &.plants {
    padding: 4% 16% 3% 12%;
  }
  &.energy {
    padding: 4% 9% 4.5% 6%;
  }
  &.heat {
    padding: 4% 14% 4% 10%;
  }
`;

const Marker = styled.div`
  background-color: rgba(0, 0, 255, 0.65);
  font-weight: bold;
  text-shadow: 2px 2px 1px black;
  height: 85%;
  width: 85%;
  border-radius: 10%;
  display: grid;
  place-items: center;

  grid-column: ${(props) => (props.col ? props.col : 1)};
  grid-row: ${(props) => (props.row ? props.row : 1)};

  svg {
    height: 100%;
    width: 100%;

    g {
      width: 100%;
      height: 100%;
    }
  }

  .sum {
    font-size: 80px;
    fill: white;
    text-align: center;
  }
`;

export default ResourceTracker;
